import { OrderProduct } from '../../modules/orders/products/orderProducts.types';
import { MediaType } from '../../types/general.types';
import { ProductsAddedCardItem } from './ProductsAddedCard/productsAddedCard.types';
import { RemoveNotifiedProductsParams } from './types/productAddNotification.types';

export const removeNotifiedProducts = ({
  orderProducts,
  removeProduct,
  removeKit,
}: RemoveNotifiedProductsParams) => {
  const kitIds = new Set(orderProducts.flatMap((product) => product.kit?.id ?? []));
  const looseProducts = orderProducts.filter((product) => !product.kit?.id);

  return Promise.all([
    ...[...kitIds].map((kitId) => removeKit(kitId)),
    ...looseProducts.map((product) => removeProduct(product, 0)),
  ]);
};

export const toProductsAddedCardItem = (orderProduct: OrderProduct): ProductsAddedCardItem => ({
  name: orderProduct.kit?.name || orderProduct.name,
  code: orderProduct.kit?.code || orderProduct.code,
  imageUrl:
    orderProduct.kit?.imageUrl ||
    (orderProduct.media?.type !== MediaType.VIDEO ? orderProduct.media?.url : undefined),
  colorName: orderProduct.color?.name,
  colorHex: orderProduct.color?.hexcode,
});
